import deLocale from './de-DE.json';
import enLocale from './en-GB.json';
import esLocale from './es-ES.json';
import etLocale from './et-EE.json';
import fiLocale from './fi-FI.json';
import frLocale from './fr-FR.json';
import nbLocale from './nb-NO.json';
import plLocale from './pl-PL.json';
import ruLocale from './ru-RU.json';
import svLocale from './sv-SE.json';

import type { Locales } from 'shared-locales';

const getMessagesByLanguage = (language: Locales) => {
  switch (language) {
    case 'de-DE':
      return deLocale;
    case 'es-ES':
      return esLocale;
    case 'et-EE':
      return etLocale;
    case 'fi-FI':
      return fiLocale;
    case 'fr-FR':
      return frLocale;
    case 'nb-NO':
      return nbLocale;
    case 'pl-PL':
      return plLocale;
    case 'ru-RU':
      return ruLocale;
    case 'sv-SE':
      return svLocale;
    default:
      // en-GB
      return enLocale;
  }
};

export default getMessagesByLanguage;
